import axios from 'axios';
import type { AxiosInstance } from 'axios';

import { httpConstants } from '../constants/appConstants';

type HttpRepositoryType = {
	tradeshiftGoFrontend: () => AxiosInstance;
	tradeshiftGo: () => AxiosInstance;
	tradeshiftGoMulti: () => AxiosInstance;
	tradeshiftBlobRequest: () => AxiosInstance;
	payments: (token: string) => AxiosInstance;
	fintechCards: (token: string) => AxiosInstance;
};

const HttpRepository: HttpRepositoryType = {
	tradeshiftGoFrontend: (): AxiosInstance =>
		axios.create({
			baseURL: '',
			timeout: httpConstants.timeout,
			withCredentials: true,
			headers: {
				'Content-Type': 'application/json',
				'X-Tradeshift-RequestId': crypto.randomUUID(),
			},
		}),
	tradeshiftGo: (): AxiosInstance =>
		axios.create({
			baseURL: `${globalThis.config.TRADESHIFT_GO_HOST}/external`,
			timeout: httpConstants.timeout,
			withCredentials: true,
			headers: {
				'Content-Type': 'application/json',
				'X-Tradeshift-RequestId': crypto.randomUUID(),
			},
		}),
	tradeshiftGoMulti: (): AxiosInstance =>
		axios.create({
			baseURL: `${globalThis.config.TRADESHIFT_GO_HOST}/external`,
			timeout: httpConstants.timeout,
			withCredentials: true,
			headers: {
				'Content-Type': 'multipart/form-data',
				'X-Tradeshift-RequestId': crypto.randomUUID(),
			},
		}),
	tradeshiftBlobRequest: (): AxiosInstance =>
		axios.create({
			baseURL: `${globalThis.config.TRADESHIFT_GO_HOST}/external`,
			timeout: httpConstants.timeout,
			withCredentials: true,
			responseType: 'blob',
			headers: {
				'X-Tradeshift-RequestId': crypto.randomUUID(),
				'Cache-Control': 'no-cache',
			},
		}),
	payments: (token: string): AxiosInstance =>
		axios.create({
			baseURL: globalThis.config.PAYMENTS_EXTERNAL_HOST,
			timeout: httpConstants.timeout,
			headers: {
				'Content-Type': 'application/json',
				Authorization: 'Bearer ' + token,
				'X-Tradeshift-RequestId': crypto.randomUUID(),
			},
		}),
	fintechCards: (token: string): AxiosInstance =>
		axios.create({
			baseURL: globalThis.config.FINTECH_PAYMENTS_HOST,
			timeout: httpConstants.timeout,
			headers: {
				'Content-Type': 'application/json',
				Authorization: 'Bearer ' + token,
				'X-Tradeshift-RequestId': crypto.randomUUID(),
			},
		}),
};

export default HttpRepository;
